import React from 'react';
import { handleKeyDown } from '../../../../../hooks/handleKeyDown';
import { EditableText } from '../../../../../shared/ui/editable-text';
import { useGroupActions } from '../hooks/useGroupActions';

interface EditableGroupNameProps {
	id: string;
	name: string;
	isCreateGroup: boolean;
	isTagsWithoutGroup: boolean;
}

export const EditableGroupName = ({
	id,
	name,
	isCreateGroup,
	isTagsWithoutGroup,
}: EditableGroupNameProps) => {
	const {
		handleGroupNameChange,
		setEditableGroup,
		setNewGroupName,
		updateGroupName,
		editableGroup,
		newGroupName,
	} = useGroupActions(name, id);

	const handleGroupNameClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (!isCreateGroup && !isTagsWithoutGroup) {
			setEditableGroup(id);
			setNewGroupName(name);
		}
	};

	const handleInputKeyDown = handleKeyDown({
		keyCode: 'Enter',
		isActive: newGroupName.trim() !== '',
		action: updateGroupName,
	});

	const handleNameKeyDown = handleKeyDown({
		keyCode: 'Enter',
		isActive: true,
		action: () => handleGroupNameClick(new MouseEvent('click') as unknown as React.MouseEvent),
	});

	return (
		<EditableText
			id={id}
			editableGroup={editableGroup}
			name={name}
			newGroupName={newGroupName}
			handleNameChange={handleGroupNameChange}
			updateGroupName={updateGroupName}
			handleInputKeyDown={handleInputKeyDown}
			handleNameKeyDown={handleNameKeyDown}
			handleNameClick={(e) => handleGroupNameClick(e)}
			paddingRight={12}
		/>
	);
};
